import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { useTranslation } from "react-i18next";

export const BackToTop = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const f = () => setShow(window.scrollY > window.innerHeight * 0.8);
    f();
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.button
          type="button"
          data-testid="back-to-top"
          aria-label={t("common.backToTop")}
          title={t("common.backToTop")}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          initial={{ opacity: 0, y: 40, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.8 }}
          whileHover={{ y: -6 }}
          whileTap={{ scale: 0.9 }}
          className="group fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-black p-1.5 pr-4 text-[#c6ff00] shadow-[0_10px_40px_-10px_rgba(198,255,0,0.5)] ring-1 ring-[#c6ff00]/40 backdrop-blur"
        >
          <span className="relative block h-11 w-11 shrink-0 overflow-hidden rounded-full bg-[#c6ff00]">
            <img src="/brand/icon.png" alt="" className="absolute inset-0 m-auto h-8 w-8 transition-transform duration-300 group-hover:-translate-y-10" />
            <ArrowUp size={18} className="absolute inset-0 m-auto translate-y-10 text-black transition-transform duration-300 group-hover:translate-y-0" />
          </span>
          <span className="text-[11px] font-bold uppercase tracking-[0.2em]">{t("common.backToTop")}</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};
